export const api = {
  defaultUrl: process.env.REACT_APP_API_URL,
  second: process.env.REACT_APP_SECOND_API
}

export const appearance = {
  theme: 'main'
}
